module.exports = __webpack_public_path__ + "img/rh.4cc4c336.png";